export default {"src":"/_next/static/media/logo-lucidity-mobile.cfa0971f.svg","height":32,"width":72,"blurWidth":0,"blurHeight":0};